import React from 'react';
import './App.css';
import Base from './base';

class Lander extends React.Component {
    constructor(props){
        super(props)
        
        var target = Math.floor(Math.random() * 50);
        var terrain_seed = Math.floor(Math.random() * 4294967296);

        this.state = {
          map_img: null,
        
          width: 0, 
          height: 0,
          
          show: true,
          withAnimation: true,
          
          
          lander: [0, 0],
          lander_angle: 0,
          lander_angle_vel: 0,
          
          lander_vel: [0, 0],
          lander_thrust_up: 0,
          lander_thrust_right: 0,
          lander_thrust_left: 0,
          lander_rotate_right: 0,
          lander_rotate_left: 0,
          
          t: 0,
          stars_phase: Array.from({length: 100}, () => Math.floor(Math.random() * 360.0)),
          stars_rad: Array.from({length: 100}, () => Math.floor(Math.random() * 1500)),
          
          terrain_seed: terrain_seed,
          landscape: Array.from({length: 50}, (_, i) => Math.floor(10 + this.seededTerrainRand(terrain_seed, i, 0) * 70)),
          landscape_colors: Array.from({length: 50}, (_, i) => Math.floor(this.seededTerrainRand(terrain_seed, i, 1) * 70)),

          target: target,
          
          width: 300,
          height: 300,
          win: "",
          landerFast: false,
          
          particles: [],
          
          level: 1,
          restartScheduled: false,
          restartCountdown: 0,
          score: 0,
          astronaut: null,
          levelRestarting: false,
          showBase: false
        }
        
        this.state.landscape[target + 1] = this.state.landscape[target];
        
        this.restartTimeoutId = null;
        this.countdownIntervalId = null;
        
    }
    
    restartLevel() {
        // Generate new target
        var target = Math.floor(Math.random() * 50);

        // Create new landscape from a fixed seed picked for this level
        var terrain_seed = Math.floor(Math.random() * 4294967296);
        var landscape = Array.from({length: 50}, (_, i) => Math.floor(10 + this.seededTerrainRand(terrain_seed, i, 0) * 70));
        var landscape_colors = Array.from({length: 50}, (_, i) => Math.floor(this.seededTerrainRand(terrain_seed, i, 1) * 70));
        landscape[target + 1] = landscape[target];
        
        // Reset game state without incrementing level or score
        this.setState({
            lander: [0, 0],
            lander_angle: 0,
            lander_angle_vel: 0,
            lander_vel: [0, 0],
            lander_thrust_up: 0,
            lander_thrust_right: 0,
            lander_thrust_left: 0,
            lander_rotate_right: 0,
            lander_rotate_left: 0,
            win: "",
            landerFast: false,
            particles: [],
            target: target,
            terrain_seed: terrain_seed,
            landscape: landscape,
            landscape_colors: landscape_colors,
            restartScheduled: false,
            restartCountdown: 0,
            astronaut: null,
            levelRestarting: false
        }, () => {
            // Spawn astronaut if level > 0
            if (this.state.level > 0) {
                // Choose a random landscape segment (not the target)
                var astronautSegment = Math.floor(Math.random() * 50);
                while (astronautSegment === this.state.target || astronautSegment === this.state.target + 1) {
                    astronautSegment = Math.floor(Math.random() * 50);
                }
                var astronautHeight = this.state.landscape[astronautSegment];
                var astronautX = this.state.width * astronautSegment / 50.0 + (this.state.width / 50.0) / 2;
                var astronautY = this.state.height - astronautHeight * this.state.height / 100.0 - 30;
                this.setState({
                    astronaut: {
                        x: astronautX,
                        y: astronautY,
                        segment: astronautSegment
                    }
                });
            }
        });
    }
    
    restartGame() {
        // Generate new target
        var target = Math.floor(Math.random() * 50);

        // Create new landscape from a fixed seed picked for this level
        var terrain_seed = Math.floor(Math.random() * 4294967296);
        var landscape = Array.from({length: 50}, (_, i) => Math.floor(10 + this.seededTerrainRand(terrain_seed, i, 0) * 70));
        var landscape_colors = Array.from({length: 50}, (_, i) => Math.floor(this.seededTerrainRand(terrain_seed, i, 1) * 70));
        landscape[target + 1] = landscape[target];
        
        // Spawn astronaut if level > 2 (will be set after state update with correct dimensions)
        var astronaut = null;
        
        // Reset game state but increment level and add to score
        this.setState({
            lander: [0, 0],
            lander_angle: 0,
            lander_angle_vel: 0,
            lander_vel: [0, 0],
            lander_thrust_up: 0,
            lander_thrust_right: 0,
            lander_thrust_left: 0,
            lander_rotate_right: 0,
            lander_rotate_left: 0,
            win: "",
            landerFast: false,
            particles: [],
            level: this.state.level + 1,
            score: this.state.score + 1000,
            target: target,
            terrain_seed: terrain_seed,
            landscape: landscape,
            landscape_colors: landscape_colors,
            restartScheduled: false,
            restartCountdown: 0,
            astronaut: null
        }, () => {
            // Spawn astronaut if level > 0
            if (this.state.level > 0) {
                // Choose a random landscape segment (not the target)
                var astronautSegment = Math.floor(Math.random() * 50);
                while (astronautSegment === this.state.target || astronautSegment === this.state.target + 1) {
                    astronautSegment = Math.floor(Math.random() * 50);
                }
                var astronautHeight = this.state.landscape[astronautSegment];
                var astronautX = this.state.width * astronautSegment / 50.0 + (this.state.width / 50.0) / 2;
                var astronautY = this.state.height - astronautHeight * this.state.height / 100.0 - 30;
                this.setState({
                    astronaut: {
                        x: astronautX,
                        y: astronautY,
                        segment: astronautSegment
                    }
                });
            }
        });
        
        this.restartTimeoutId = null;
        if (this.countdownIntervalId) {
            clearInterval(this.countdownIntervalId);
            this.countdownIntervalId = null;
        }
    }
      
    // Deterministic value in [0, 1) for terrain column i, derived from the level's fixed seed.
    // Lets the terrain extend to any column index (negative or beyond 50) without storing it.
    seededTerrainRand(seed, i, salt) {
        var h = (seed ^ Math.imul(i, 0x9E3779B9) ^ Math.imul(salt + 1, 0x85EBCA6B)) >>> 0;
        h = Math.imul(h ^ (h >>> 16), 0x45D9F3B) >>> 0;
        h = Math.imul(h ^ (h >>> 16), 0x45D9F3B) >>> 0;
        h = (h ^ (h >>> 16)) >>> 0;
        return h / 4294967296;
    }

    getTerrainHeight(i) {
        if (i >= 0 && i < this.state.landscape.length) {
            return this.state.landscape[i];
        }
        return Math.floor(10 + this.seededTerrainRand(this.state.terrain_seed, i, 0) * 70);
    }

    getTerrainColor(i) {
        if (i >= 0 && i < this.state.landscape_colors.length) {
            return this.state.landscape_colors[i];
        }
        return Math.floor(this.seededTerrainRand(this.state.terrain_seed, i, 1) * 70);
    }

    checkLandscapeCollision(x1, y1, x2, y2, x3, y3, x4, y4) {
        if (x3 >= x1 && x3 <= x2) {
          if (y4 >= y1) {
            return true;
          }
        }
        
        if (x4 >= x1 && x4 <= x2) {
          if (y4 >= y1) {
            return true;
          }
        }
        
        return false;
      }
      
      animationFrame() {
      
        // Lander physics
        var lander = this.state.lander;
        var lander_vel = this.state.lander_vel;
        var lander_angle = this.state.lander_angle;
        var lander_angle_vel = this.state.lander_angle_vel;
        
        var t = this.state.t;
        
        t = t + 1;
        
        lander[0] = 0.030 * lander_vel[0] + lander[0];
        lander[1] = 0.030 * lander_vel[1] + lander[1];
        
        lander_angle = 0.030 * lander_angle_vel + lander_angle;
        
        // Gravity
        lander_vel[0] = 0.030 * 10 + lander_vel[0];
         
        if (this.state.lander_thrust_up == 1) {
          lander_vel[0] = -0.07 * 60 * Math.sin((lander_angle + 90 ) / 180 * Math.PI) + lander_vel[0];
          lander_vel[1] = -0.07 * 60 * Math.cos((lander_angle + 90) / 180 * Math.PI) + lander_vel[1];
        }
        
        // Particle system
        var particles = this.state.particles;
        
        // Create new particles when thrust is active
        if (this.state.lander_thrust_up == 1) {


          var newParticles = Array.from({length: 3}, () => {
            // Random color from orange to red for thrust particles
            const colorRand = Math.random();
            let color;
            if (colorRand < 0.5) {
              // Orange shades
              const orangeIntensity = Math.floor(200 + Math.random() * 55);
              color = `rgb(255, ${orangeIntensity}, 0)`;
            } else {
              // Red shades
              const redIntensity = Math.floor(150 + Math.random() * 105);
              color = `rgb(255, ${Math.floor(redIntensity * 0.3)}, 0)`;
            }
            
            return {
              x: lander[1] + Math.sin(-this.state.lander_angle / 180 * Math.PI) * 30 
                 + Math.cos(this.state.lander_angle / 180 * Math.PI) * 10 + (Math.random() - 0.5) * 10,
              y: lander[0] + Math.cos(-this.state.lander_angle / 180 * Math.PI) * 30 
                 + Math.sin(this.state.lander_angle / 180 * Math.PI) * 10 + (Math.random() - 0.5) * 10,
              vx: (Math.random() - 0.5) * 0.5 + Math.sin(-this.state.lander_angle / 180 * Math.PI) * 3.0,
              vy: (Math.random() - 0.5) * 0.5 + Math.cos(-this.state.lander_angle / 180 * Math.PI) * 3.0,
              life: 30,
              size: 3 + Math.random() * 3,
              color: color
            };
          });
          
          particles = [...particles, ...newParticles];
        }
        
        // Update and filter particles
        particles = particles.map(p => ({
          ...p,
          x: p.x + p.vx,
          y: p.y + p.vy,
          life: p.life - 1
        })).filter(p => p.life > 0);
        
        if (this.state.lander_thrust_right == 1) {
          lander_vel[1] = 0.030 * 10 + lander_vel[1];
        }
        
        if (this.state.lander_thrust_left == 1) {
          lander_vel[1] = -0.030 * 10 + lander_vel[1];
        } 
        
        if (this.state.lander_rotate_right == 1) {
          lander_angle_vel = 0.10 * 10 + lander_angle_vel;
        }
        
        if (this.state.lander_rotate_left == 1) {
          lander_angle_vel = -0.10 * 10 + lander_angle_vel;
        } 
        
        var win = "";
        var landerFast = false;
      
        if (Math.sqrt(lander_vel[0] * lander_vel[0] + lander_vel[1] * lander_vel[1]) < 20) {
        }
        else {
          landerFast = true;
        }
    
        // Lander collisions - check the seeded terrain columns under the lander,
        // which also exist beyond the base 50 columns
        const colW = this.state.width / 50.0;
        const colStart = Math.floor(lander[1] / colW) - 1;
        const colEnd = Math.floor((lander[1] + 30) / colW) + 1;
        for (var i = colStart; i <= colEnd; i++) {
          const __ = this.getTerrainHeight(i);
          const y1 = this.state.height - __ * this.state.height / 100.0;
          const x1 = this.state.width * i / 50.0;
          const y2 = y1 + __ * this.state.height / 100.0;
          const x2 = x1 + this.state.width / 50.0;
          
          const x3 = lander[1];
          const y3 = lander[0];
          const x4 = lander[1] + 30;
          const y4 = lander[0] + 30;
          
          if (this.checkLandscapeCollision(x1, y1, x2, y2, x3, y3, x4, y4)) {
          
            if (Math.sqrt(lander_vel[0] * lander_vel[0] + lander_vel[1] * lander_vel[1]) < 20) {
              if (lander_vel[0] >= 0) {
                // you landed
                lander_vel = [0, 0];
                lander_angle_vel = 0;
                lander_angle = 0;
                
                if (i == this.state.target || i == this.state.target + 1) {
                  win = "YOU WIN!!!";
                } 
              }
            }
            else 
            {
              // You died - create explosion
              var crashX = lander[1] + 15;
              var crashY = lander[0] + 15;
              
              // Create explosion particles
              var explosionParticles = Array.from({length: 35}, () => {
                var angle = Math.random() * Math.PI * 2;
                var speed = Math.random() * 5 + 2;
                
                // Random color: white, yellow, or red
                const colorRand = Math.random();
                let color;
                if (colorRand < 0.33) {
                  // White
                  const whiteIntensity = Math.floor(200 + Math.random() * 55);
                  color = `rgb(${whiteIntensity}, ${whiteIntensity}, ${whiteIntensity})`;
                } else if (colorRand < 0.66) {
                  // Yellow
                  const yellowIntensity = Math.floor(200 + Math.random() * 55);
                  color = `rgb(255, ${yellowIntensity}, 0)`;
                } else {
                  // Red
                  const redIntensity = Math.floor(150 + Math.random() * 105);
                  color = `rgb(255, ${Math.floor(redIntensity * 0.2)}, 0)`;
                }
                
                return {
                  x: crashX + (Math.random() - 0.5) * 10,
                  y: crashY + (Math.random() - 0.5) * 10,
                  vx: Math.cos(angle) * speed,
                  vy: Math.sin(angle) * speed,
                  life: 40 + Math.floor(Math.random() * 20),
                  size: 15 + Math.random() * 15,
                  color: color
                };
              });
              
              // Update explosion particles immediately so they start moving this frame
              explosionParticles = explosionParticles.map(p => ({
                ...p,
                x: p.x + p.vx,
                y: p.y + p.vy,
                life: p.life - 1
              }));
              
              particles = [...particles, ...explosionParticles];
              
              lander = [0, 0];
              lander_vel = [0, 0];
              lander_angle_vel = 0;
              lander_angle = 0;
            }
          }
        }

        // Check astronaut collision
        var score = this.state.score;
        if (this.state.astronaut) {
            const landerX = lander[1];
            const landerY = lander[0];
            const landerSize = 30;
            const astronautX = this.state.astronaut.x;
            const astronautY = this.state.astronaut.y;
            const astronautSize = 20;
            
            // Simple bounding box collision
            if (landerX < astronautX + astronautSize &&
                landerX + landerSize > astronautX &&
                landerY < astronautY + astronautSize &&
                landerY + landerSize > astronautY) {
                // Lander touched astronaut - add 200 to score and remove astronaut
                score = this.state.score + 200;
                this.setState({ astronaut: null, score: score });
            }
        }
      
        // Check if player just won and schedule restart
        const justWon = win === "YOU WIN!!!" && this.state.win !== "YOU WIN!!!";
        
        this.setState({ landerFast, win: win, lander: lander, lander_vel: lander_vel, lander_angle: lander_angle, lander_angle_vel: lander_angle_vel, t: t, particles: particles }, () => {
            // After state update, schedule restart if just won
            if (justWon && !this.state.restartScheduled) {
                this.setState({ restartScheduled: true, restartCountdown: 5 });
                // Clear any existing timeout and interval
                if (this.restartTimeoutId) {
                    clearTimeout(this.restartTimeoutId);
                }
                if (this.countdownIntervalId) {
                    clearInterval(this.countdownIntervalId);
                }
                // Start countdown interval (update every second)
                this.countdownIntervalId = setInterval(() => {
                    this.setState((prevState) => {
                        if (prevState.restartCountdown > 1) {
                            return { restartCountdown: prevState.restartCountdown - 1 };
                        } else {
                            // Countdown finished, switch to base view
                            if (this.countdownIntervalId) {
                                clearInterval(this.countdownIntervalId);
                                this.countdownIntervalId = null;
                            }
                            return { restartCountdown: 0 };

                            // Clear any pending restart timeout
                            //if (this.restartTimeoutId) {
                            //    clearTimeout(this.restartTimeoutId);
                            //   this.restartTimeoutId = null;
                            //}
                            //return { restartCountdown: 0, showBase: true };
                        }
                    });
                }, 1000);
                // Schedule restart after 5 seconds
                this.restartTimeoutId = setTimeout(() => {
                    this.restartGame();
                }, 5000);
            }
        });
      
        var animationFrame = this.animationFrame;
        
        setTimeout(function() { 
          animationFrame();
          }, 30);
      }

    updateWindowDimensions() {
        if (document.getElementById('sizer') !== null) {
          const height = document.getElementById('sizer').offsetHeight;
          const width = document.getElementById('sizer').offsetWidth;
      
        
          this.setState({ 
            width: width, 
            height: height
            });
        }
    }

    render() {
        // If showBase is true, render the Base component instead
        if (this.state.showBase) {
            return <Base 
                score={this.state.score} 
                level={this.state.level}
                onScoreUpdate={(points) => {
                    this.setState({ score: this.state.score + points });
                }}
            />;
        }
        
        let velocity = Math.round(Math.sqrt(this.state.lander_vel[0] * this.state.lander_vel[0] + this.state.lander_vel[1] * this.state.lander_vel[1]));
        
        // Calculate inclination angle (normalize to -180 to 180)
        let inclination = this.state.lander_angle;
        while (inclination > 180) inclination -= 360;
        while (inclination < -180) inclination += 360;
        inclination = Math.round(inclination);
        
        // Check if inclination is beyond -20 or 20 degrees
        const isInclinationWarning = Math.abs(inclination) > 20;

        // Camera: when the lander flies out of the base screen area, zoom out so the
        // spacecraft stays in the scene, keeping the ground anchored at the bottom.
        const W = this.state.width;
        const H = this.state.height;
        // Margin scales with how far out the craft is, so zoom is exactly 1 on-screen
        // and eases out smoothly once the craft crosses an edge
        const camMargin = 1.4;
        const boundLeft = Math.min(0, this.state.lander[1]) * camMargin;
        const boundRight = W + Math.max(0, this.state.lander[1] + 30 - W) * camMargin;
        const boundTop = Math.min(0, this.state.lander[0]) * camMargin;
        const spanW = boundRight - boundLeft;
        const spanH = H - boundTop;
        const aspect = W > 0 && H > 0 ? W / H : 1;
        const viewW = Math.max(spanW, spanH * aspect);
        const viewH = viewW / aspect;
        const viewX = boundLeft - (viewW - spanW) / 2;
        const viewY = H - viewH;
        const zoom = W > 0 ? W / viewW : 1;

        // Terrain columns visible in the current view (the seed supplies columns
        // beyond the base 50 as the view grows)
        const colWidth = W / 50.0;
        const terrainCols = [];
        for (var ti = Math.floor(viewX / colWidth) - 1; ti <= Math.ceil((viewX + viewW) / colWidth) + 1; ti++) {
            terrainCols.push(ti);
        }

        return (
            <div 
            id="landermain"
            className="lander-background"
            tabIndex="0"
        
            onKeyDown={(event) => {
            if (event.key == 'ArrowUp' || event.key == 'W' || event.key == 'w') {
                this.setState( { lander_thrust_up: 1 } );
            }
            
            if (event.key == 'ArrowRight' || event.key == 'D' || event.key == 'd') {
                this.setState( { lander_rotate_right: 1 } );
            }
            
            if (event.key == 'ArrowLeft' || event.key == 'A' || event.key == 'a') {
                this.setState( { lander_rotate_left: 1 } );
            }
            }}
            onKeyUp={(event) => {
            
            if (event.key == 'ArrowUp' || event.key == 'W' || event.key == 'w') {
                this.setState( { lander_thrust_up: 0 } );
            }
            
            if (event.key == 'ArrowRight' || event.key == 'D' || event.key == 'd') {
                this.setState( { lander_rotate_right: 0 } );
            }
            
            if (event.key == 'ArrowLeft' || event.key == 'A' || event.key == 'a') {
                this.setState( { lander_rotate_left: 0 } );
            }
            }}>    
        
            { this.state.stars_phase.map( (_, i) =>
            <div
                key={ "star_" + i }
                style={{
                top: Math.min(Math.sin(_ + this.state.t * 0.001) * this.state.stars_rad[i], this.state.height - 4), 
                left: Math.cos(_ + this.state.t * 0.001) * this.state.stars_rad[i] }}
                className="star">
            </div>
            )}

            <div
            className="lander-camera"
            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", transform: `translate(${-viewX * zoom}px, ${-viewY * zoom}px) scale(${zoom})`, transformOrigin: "0 0" }}>

            <div
            style={{ top: this.state.lander[0] + "px", left: this.state.lander[1] + "px", transform: "rotate(" + this.state.lander_angle + "deg)" }}
            className={ `lander ${ this.state.lander_thrust_up ? "up-thrust" : "" } ${ this.state.lander_thrust_left ? "left-thrust" : "" } ${ this.state.lander_thrust_right ? "right-thrust" : "" }`}
            >
            <div className={'lander-left-leg'}></div>
            <div className={'lander-right-leg'}></div>
            <div className={'lander-head'}></div>
            { this.state.lander_thrust_up == 1 ? <div className={'lander-flame'}></div> : null }
        </div>
        
            { this.state.particles.map( (particle, i) => 
            <div 
                key={ "particle_" + i }
                style={{ 
                    position: "absolute",
                    top: particle.y + "px",
                    left: particle.x + "px",
                    width: particle.size + "px",
                    height: particle.size + "px",
                    borderRadius: "50%",
                    backgroundColor: particle.color || "red",
                    pointerEvents: "none"
                }}
                className="particle">
            </div>
            )}
            
            {/* Astronaut */}
            { this.state.astronaut && (
                <div
                    key="astronaut"
                    style={{
                        position: "absolute",
                        top: this.state.astronaut.y + "px",
                        left: (this.state.astronaut.x - 10) + "px",
                        width: "20px",
                        height: "20px",
                        pointerEvents: "none",
                        zIndex: 5
                    }}
                    className="astronaut">
                    {/* Head */}
                    <div style={{
                        position: "absolute",
                        top: "0px",
                        left: "6px",
                        width: "8px",
                        height: "8px",
                        backgroundColor: "#ffdbac",
                        borderRadius: "50%",
                        border: "1px solid #fff"
                    }}></div>
                    {/* Body */}
                    <div style={{
                        position: "absolute",
                        top: "8px",
                        left: "5px",
                        width: "10px",
                        height: "10px",
                        backgroundColor: "#ffffff",
                        border: "1px solid #fff"
                    }}></div>
                    {/* Arms */}
                    <div style={{
                        position: "absolute",
                        top: "9px",
                        left: "0px",
                        width: "5px",
                        height: "3px",
                        backgroundColor: "#ffffff",
                        border: "1px solid #fff"
                    }}></div>
                    <div style={{
                        position: "absolute",
                        top: "9px",
                        right: "0px",
                        width: "5px",
                        height: "3px",
                        backgroundColor: "#ffffff",
                        border: "1px solid #fff"
                    }}></div>
                    {/* Legs */}
                    <div style={{
                        position: "absolute",
                        top: "18px",
                        left: "5px",
                        width: "4px",
                        height: "10px",
                        backgroundColor: "#0000ff",
                        border: "1px solid #fff"
                    }}></div>
                    <div style={{
                        position: "absolute",
                        top: "18px",
                        right: "5px",
                        width: "4px",
                        height: "10px",
                        backgroundColor: "#0000ff",
                        border: "1px solid #fff"
                    }}></div>
                </div>
            )}
            
            { terrainCols.map( (i) => {
                const colHeight = this.getTerrainHeight(i);
                const colColor = this.getTerrainColor(i);
                const baseColor = i == this.state.target || i == this.state.target + 1 ?
                    "#4444DD"
                    : "#" + (255 - colColor).toString(16) + (255 - colColor).toString(16) + (255 - colColor).toString(16);

                let darkerColor;
                if (i == this.state.target || i == this.state.target + 1) {
                    darkerColor = "#222288";
                } else {
                    const rgbValue = 255 - colColor;
                    const darkerRgb = Math.max(0, rgbValue - 30);
                    const hexValue = darkerRgb.toString(16).padStart(2, '0');
                    darkerColor = "#" + hexValue + hexValue + hexValue;
                }

                return (
                <div
                    key={ "land_" + i }
                    style={{
                    top: this.state.height - colHeight * this.state.height / 100,
                    left: this.state.width * i / 50.0,
                    width: this.state.width / 50.0,
                    height: (colHeight * this.state.height / 100),
                    background: `linear-gradient(to right, ${baseColor}, ${darkerColor})`
                    }}
                    className="moon">
                </div>
                );
            })}
            
            {/* Target highlight overlay */}
            {(() => {
                const targetHeight1 = this.state.landscape[this.state.target];
                const targetHeight2 = this.state.landscape[this.state.target + 1];
                const targetTop = this.state.height - Math.max(targetHeight1, targetHeight2) * this.state.height / 100;
                const targetLeft = this.state.width * this.state.target / 50.0;
                const targetWidth = (this.state.width / 50.0) * 2;
                const targetHeight = Math.max(targetHeight1, targetHeight2) * this.state.height / 100;
                
                return (
                    <div
                        key="target-highlight"
                        style={{
                            position: "absolute",
                            top: targetTop + "px",
                            left: targetLeft + "px",
                            width: targetWidth + "px",
                            height: targetHeight + "px",
                            border: "3px solid #00ffff",
                            borderRadius: "4px",
                            boxShadow: `
                                0 0 10px rgba(0, 255, 255, 0.8),
                                0 0 20px rgba(0, 255, 255, 0.5),
                                inset 0 0 10px rgba(0, 255, 255, 0.3)
                            `,
                            pointerEvents: "none",
                            zIndex: 10,
                            animation: "pulse 2s ease-in-out infinite"
                        }}
                        className="target-highlight">
                        <div style={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "#00ffff",
                            textShadow: "0 0 5px rgba(0, 255, 255, 0.8)",
                            whiteSpace: "nowrap"
                        }}>
                            TARGET
                        </div>
                    </div>
                );
            })()}

            </div>

            <div className="win-state">
            <p style={{ fontSize: "1.5em", color: "#00FF00" }}>
                { this.state.win }
                { this.state.win === "YOU WIN!!!" && this.state.restartCountdown > 0 && 
                    <span> NEXT LEVEL IN {this.state.restartCountdown}...</span>
                }
            </p>
            </div>
            
            <div className="instructions">
            <p style={{ fontSize: "1.2em"}} >CLICK TO PLAY!</p>
            <p> </p>
            <p>LEFT AND RIGHT ARROW KEYS ROTATE THE VESSEL</p>
            <p>UP ARROW TO THRUST.  WASD KEYS ALSO WORK.</p>
            <p>LAND ON THE BLUE DESTINATION PILLAR <font style={{color: "red"}}>SLOWLY (VELOCITY LESS THAN 20)</font></p>
            { /* <p>Y VELOCITY: { velocity } { this.state.landerFast && <font style={{color: "red"}}>TOO FAST TO LAND</font>}</p> */ }
            </div>
            
            {/* Inclination display */}
            <div 
                style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "170px",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    border: "2px solid " + (isInclinationWarning ? "#ff0000" : "#ffffff"),
                    borderRadius: "8px",
                    padding: "10px 15px",
                    fontFamily: "monospace",
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: isInclinationWarning ? "#ff0000" : "#00ff00",
                    textShadow: "0 0 5px " + (isInclinationWarning ? "rgba(255, 0, 0, 0.8)" : "rgba(0, 255, 0, 0.8)"),
                    boxShadow: "0 0 10px " + (isInclinationWarning ? "rgba(255, 0, 0, 0.5)" : "rgba(0, 255, 0, 0.3)"),
                    zIndex: 1000,
                    pointerEvents: "none",
                    minWidth: "120px"
                }}
                className="inclination-meter">
                <div style={{ fontSize: "12px", color: "#cccccc", marginBottom: "5px" }}>INCLINATION</div>
                <div style={{ fontSize: "24px", lineHeight: "1", marginBottom: "8px" }}>
                    {inclination > 0 ? "+" : ""}{inclination}° 
                </div>
                {/* Needle indicator gauge */}
                <div style={{
                    width: "100%",
                    height: "60px",
                    position: "relative",
                    marginTop: "5px"
                }}>
                    {/* Gauge background */}
                    <div style={{
                        position: "absolute",
                        width: "100%",
                        height: "50px",
                        borderTop: "2px solid " + (isInclinationWarning ? "rgba(255, 0, 0, 0.5)" : "rgba(255, 255, 255, 0.3)"),
                        borderLeft: "2px solid " + (isInclinationWarning ? "rgba(255, 0, 0, 0.5)" : "rgba(255, 255, 255, 0.3)"),
                        borderRight: "2px solid " + (isInclinationWarning ? "rgba(255, 0, 0, 0.5)" : "rgba(255, 255, 255, 0.3)"),
                        borderRadius: "50% 50% 0 0",
                        overflow: "hidden"
                    }}>
                        {/* Warning zones */}
                        <div style={{
                            position: "absolute",
                            left: "0%",
                            top: "0",
                            width: "20%",
                            height: "100%",
                            backgroundColor: "rgba(255, 0, 0, 0.2)",
                            borderRight: "1px solid rgba(255, 0, 0, 0.5)"
                        }}></div>
                        <div style={{
                            position: "absolute",
                            right: "0%",
                            top: "0",
                            width: "20%",
                            height: "100%",
                            backgroundColor: "rgba(255, 0, 0, 0.2)",
                            borderLeft: "1px solid rgba(255, 0, 0, 0.5)"
                        }}></div>
                        {/* Center marker */}
                        <div style={{
                            position: "absolute",
                            left: "50%",
                            top: "0",
                            width: "2px",
                            height: "100%",
                            backgroundColor: isInclinationWarning ? "rgba(255, 0, 0, 0.8)" : "rgba(0, 255, 0, 0.8)",
                            transform: "translateX(-50%)"
                        }}></div>
                    </div>
                    {/* Needle */}
                    <div style={{
                        position: "absolute",
                        bottom: "0",
                        left: "50%",
                        width: "2px",
                        height: "45px",
                        backgroundColor: isInclinationWarning ? "#ff0000" : "#00ff00",
                        transformOrigin: "bottom center",
                        transform: `translateX(-50%) rotate(${Math.max(-90, Math.min(90, inclination * 1.5))}deg)`,
                        boxShadow: "0 0 5px " + (isInclinationWarning ? "rgba(255, 0, 0, 0.8)" : "rgba(0, 255, 0, 0.8)"),
                        transition: "transform 0.1s ease-out",
                        zIndex: 2
                    }}></div>
                    {/* Center dot */}
                    <div style={{
                        position: "absolute",
                        bottom: "0",
                        left: "50%",
                        width: "8px",
                        height: "8px",
                        backgroundColor: isInclinationWarning ? "#ff0000" : "#00ff00",
                        borderRadius: "50%",
                        transform: "translate(-50%, 50%)",
                        boxShadow: "0 0 5px " + (isInclinationWarning ? "rgba(255, 0, 0, 0.8)" : "rgba(0, 255, 0, 0.8)"),
                        zIndex: 3
                    }}></div>
                </div>
            </div>
            
            <div 
                style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "20px",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    border: "2px solid " + (velocity > 20 ? "#ff0000" : "#ffffff"),
                    borderRadius: "8px",
                    padding: "10px 15px",
                    fontFamily: "monospace",
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: velocity > 20 ? "#ff0000" : "#00ff00",
                    textShadow: "0 0 5px " + (velocity > 20 ? "rgba(255, 0, 0, 0.8)" : "rgba(0, 255, 0, 0.8)"),
                    boxShadow: "0 0 10px " + (velocity > 20 ? "rgba(255, 0, 0, 0.5)" : "rgba(0, 255, 0, 0.3)"),
                    zIndex: 1000,
                    pointerEvents: "none",
                    minWidth: "120px"
                }}
                className="speedometer">
                <div style={{ fontSize: "12px", color: "#cccccc", marginBottom: "5px" }}>SPEED</div>
                <div style={{ fontSize: "24px", lineHeight: "1", marginBottom: "8px" }}>
                    {velocity} <span style={{ fontSize: "14px", color: "#888888" }}>m/s</span>
                </div>
                <div style={{
                    width: "100%",
                    height: "6px",
                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                    borderRadius: "3px",
                    overflow: "hidden",
                    position: "relative"
                }}>
                    <div style={{
                        width: Math.min(100, (velocity / 50) * 100) + "%",
                        height: "100%",
                        backgroundColor: velocity > 20 ? "#ff0000" : "#00ff00",
                        boxShadow: "0 0 8px " + (velocity > 20 ? "rgba(255, 0, 0, 0.8)" : "rgba(0, 255, 0, 0.8)"),
                        transition: "width 0.1s ease-out, background-color 0.1s ease-out",
                        borderRadius: "3px"
                    }}></div>
                    {velocity > 20 && (
                        <div style={{
                            position: "absolute",
                            left: "40%",
                            top: "50%",
                            transform: "translateY(-50%)",
                            width: "2px",
                            height: "100%",
                            backgroundColor: "#ffffff",
                            opacity: 0.5
                        }}></div>
                    )}
                </div>
            </div>
            
            {/* Level display */}
            <div 
                style={{
                    position: "absolute",
                    bottom: "20px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    border: "2px solid #ffffff",
                    borderRadius: "8px",
                    padding: "8px 20px",
                    fontFamily: "monospace",
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#00ff00",
                    textShadow: "0 0 5px rgba(0, 255, 0, 0.8)",
                    boxShadow: "0 0 10px rgba(0, 255, 0, 0.3)",
                    zIndex: 1000,
                    pointerEvents: "none"
                }}
                className="level-display">
                LEVEL {this.state.level}
            </div>

            {/* Zoom indicator - shown when the camera zooms out to follow the lander */}
            { zoom < 0.999 && (
            <div
                style={{
                    position: "absolute",
                    top: "20px",
                    left: "20px",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    border: "2px solid #00ffff",
                    borderRadius: "8px",
                    padding: "8px 20px",
                    fontFamily: "monospace",
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#00ffff",
                    textShadow: "0 0 5px rgba(0, 255, 255, 0.8)",
                    boxShadow: "0 0 10px rgba(0, 255, 255, 0.3)",
                    zIndex: 1000,
                    pointerEvents: "none"
                }}
                className="zoom-display">
                ZOOM x{zoom.toFixed(2)}
            </div>
            )}

            {/* Score display */}
            <div 
                style={{
                    position: "absolute",
                    bottom: "20px",
                    right: "20px",
                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                    border: "2px solid #ffffff",
                    borderRadius: "8px",
                    padding: "8px 20px",
                    fontFamily: "monospace",
                    fontSize: "16px",
                    fontWeight: "bold",
                    color: "#00ff00",
                    textShadow: "0 0 5px rgba(0, 255, 0, 0.8)",
                    boxShadow: "0 0 10px rgba(0, 255, 0, 0.3)",
                    zIndex: 1000,
                    pointerEvents: "none"
                }}
                className="score-display">
                SCORE: {this.state.score.toLocaleString()}
            </div>
        
            
        </div>
        );
    }

    componentDidMount() {
        console.log("Lander mounted");
        
        this.updateWindowDimensions();
        //window.addEventListener('resize', this.updateWindowDimensions);
        window.addEventListener('load', this.updateWindowDimensions);

        // Stop Safari from scrolling the page when the game keys are pressed
        this.preventGameKeyScroll = (event) => {
            if (event.key == 'ArrowUp' || event.key == 'ArrowDown' || event.key == 'ArrowLeft' || event.key == 'ArrowRight' || event.key == ' ') {
                event.preventDefault();
            }
        };
        window.addEventListener('keydown', this.preventGameKeyScroll, { passive: false });

        // Bindings
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.restartGame = this.restartGame.bind(this);
        this.restartLevel = this.restartLevel.bind(this);
        
        // Animations
        this.animationFrame = this.animationFrame.bind(this);

        // Setup animations
        var animationFrame = this.animationFrame;
        
        setTimeout(function() { 
          animationFrame();
          }, 30); 
    }

    componentWillUnmount() {
        //window.removeEventListener('resize', this.updateWindowDimensions);
        window.removeEventListener('keydown', this.preventGameKeyScroll);
        if (this.restartTimeoutId) {
            clearTimeout(this.restartTimeoutId);
            this.restartTimeoutId = null;
        }
        if (this.countdownIntervalId) {
            clearInterval(this.countdownIntervalId);
            this.countdownIntervalId = null;
        }
    }
}

export default Lander;